export default __webpack_public_path__ + "static/media/icon-discord-colored.b8c8bd9f.svg";